export default __webpack_public_path__ + "assets/297ce0ae019c14c5c41ec288bbe5d3c8.png";